import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { BsCalendar2 } from "react-icons/bs";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import axios from "axios";
import { toast } from "react-toastify";
import API_URL from "../../../config";
import tabbyImages from "../../../assets/tabbytamara.png";

const ContactUsPage = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const extractLeafSubservices = (nodes) => {
    let result = [];
    for (const node of nodes) {
      const hasChildren =
        Array.isArray(node.children) && node.children.length > 0;
      if (node.name && !hasChildren) {
        result.push({
          label: node.name,
          value: node.name.toLowerCase().replace(/\s+/g, "_"),
        });
      }
      if (hasChildren) {
        result = result.concat(extractLeafSubservices(node.children));
      }
    }
    return result;
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/layout/header`)
      .then((response) => {
        const submenu = response.data?.Submenu || [];
        const formattedOptions = extractLeafSubservices(submenu);
        setOptions(formattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching subservices:", error);
      });
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    email: "",
    phone: "",
    profession: "",
    wellnessGoals: [],
    appointmentDate: null,
    consent: false,
  });

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };
  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleServiceChange = (selectedOptions) => {
    setSelectedServices(selectedOptions);
    setFormData({
      ...formData,
      interestin: selectedOptions.map((option) => option.label).join(", "),
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // const date = formData.appointmentDate;
    // const formattedDate = date
    //   ? `${String(date.getDate()).padStart(2, "0")}/${String(
    //       date.getMonth() + 1
    //     ).padStart(2, "0")}/${date.getFullYear()} ${
    //       date.getHours() % 12 || 12
    //     }:${String(date.getMinutes()).padStart(2, "0")} ${
    //       date.getHours() >= 12 ? "PM" : "AM"
    //     }`
    //   : "";
    const payload = {
      ...formData,
      // appointmentDate: formattedDate,
    };

    console.log("Payload in multi form", payload);
    try {
      const res = await axios.post(`${API_URL}/layout/send-mail`, payload);
      if (res.data.success) {
        toast.success("Thanks for connecting with us");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          gender: "",
          profession: "",
          wellnessGoals: [],
          interestin: "",
          appointmentDate: null,
        });
      } else {
        toast.error("Oops! There was an issue with your submission.");
      }
    } catch (error) {
      toast.error("❌ Failed to submit. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const faqs = [
    {
      question: "What services does your clinic offer?",
      answer:
        "We offer a wide range of skincare treatments tailored to meet your specific needs. Our services include facials, chemical peels, microdermabrasion, anti-aging treatments, acne management, and more.",
    },
    {
      question: "How do I know which treatment is right for me?",
      answer:
        "During your consultation, our experienced team will assess your skin's condition, discuss your concerns and goals, and recommend a personalized treatment plan that suits your needs.",
    },
    {
      question: "What can I expect during my first visit?",
      answer:
        "Your first visit will begin with a warm welcome from our friendly staff. We'll start with a detailed consultation to understand your skin's history and your goals.",
    },
    {
      question: "Are the treatments safe for all skin types?",
      answer:
        "Yes, our treatments are safe and effective for all skin types. Our team of experts is highly trained in treating a variety of skin concerns across different skin types and tones.",
    },
    {
      question: "How often should I schedule treatments?",
      answer:
        "The frequency of your treatments will depend on the specific service you're receiving and your individual skin needs. During your consultation, we'll discuss a treatment schedule.",
    },
  ];

  return (
    <div className="contact-page heading-margin">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className=" mb-3">
            <Link to="/">Home</Link> / <span>Contact Us</span>
          </div>
          <div className="contact-grid">
            {/* Contact Details */}

            <div className="contact-details">
              <h2>Get In Touch With Us!</h2>

              <div className="contact-method">
                <h3>Phone</h3>
                <p>
                  <i
                    className="fa-brands fa-whatsapp"
                    style={{ marginRight: "10px" }}
                  ></i>
                  <i
                    className="fa-solid fa-phone"
                    style={{ marginRight: "10px" }}
                  ></i>
                  <span>+971 55 120 0086</span>
                  <br />
                  <i
                    className="fa-solid fa-phone"
                    style={{ marginRight: "10px" }}
                  ></i>
                  +971 4 547 9492
                </p>
              </div>

              <div className="contact-method">
                <h3>Email</h3>
                <p>
                  <strong>For General matters:</strong>
                  <br />
                  contact@elitebodyhome.com
                  <br />
                  <strong>For Suggestions & Complains</strong>
                  <br />
                  feedback@elitebodyhome.com
                  <br />
                  <strong>Strategic & B2B matters</strong>
                  <br />
                  mohammed@elitebodyhome.com
                </p>
              </div>

              <div className="contact-method">
                <h3>Address</h3>
                <p>
                  Elite Body Home Poly Clinic L.L.C
                  <br />
                  1st Floor Office 117 Block B<br />
                  Al Hudaiba Awards Building 2nd December Interchange
                  <br />
                  Jumeirah St. Dubai, UAE
                </p>
              </div>
            </div>

            {/* Map */}
            <div className="contact-map">
              <iframe
                title="Clinic Location"
                src="https://maps.google.com/maps?q=Elite%20Body%20Home%20Aesthetic%20Polyclinic&t=m&z=14&output=embed&iwloc=near"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>

            {/* Contact Form */}
            <div className="contact-form-container">
              <form
                onSubmit={handleSubmit}
                className="rounded-4 p-2 sm-p-4 shadow form-card"
                style={{
                  border: "2px solid #c69933",
                  background: "#fbf5e5",
                  maxWidth: "520px",
                }}
              >
                {/* Header */}
                <div
                  className="p-2 mb-3 rounded-3 text-white text-center"
                  style={{
                    background: "linear-gradient(to right, #bdaa7d, #c69933)",
                  }}
                >
                  <h2 className="h3 fw-bold">Fill in your details below</h2>
                  <p className="text-light mt-1">
                    {" "}
                    Claim Your <span className="fw-bolder">30% Discount</span>
                  </p>
                </div>

                {/* Timeline Progress */}
                <div
                  className="progress-timeline d-flex justify-content-between align-items-center my-2 px-2"
                  style={{ marginLeft: "70px" }}
                >
                  {[1, 2, 3].map((s, i) => (
                    <div className="timeline-step" key={i}>
                      <div
                        className={`circle ${step >= s ? "active" : ""}`}
                      ></div>
                      {s !== 3 && (
                        <div
                          className={`line ${step > s ? "active" : ""}`}
                        ></div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Step 1 */}
                {step === 1 && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        className="form-control custom-input"
                        required
                        placeholder="Enter first name"
                        value={formData.firstName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            firstName: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        className="form-control custom-input"
                        required
                        placeholder="Enter last name"
                        value={formData.lastName}
                        onChange={(e) =>
                          setFormData({ ...formData, lastName: e.target.value })
                        }
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select custom-input py-2"
                        required
                        value={formData.gender}
                        onChange={(e) =>
                          setFormData({ ...formData, gender: e.target.value })
                        }
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                        <option value="prefer_not_say">
                          Prefer not to say
                        </option>
                      </select>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={nextStep}
                        style={{
                          backgroundColor: "#bdaa7d",
                          border: "2px solid #c69933",
                        }}
                      >
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </>
                )}

                {/* Step 2 */}
                {step === 2 && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control custom-input"
                        required
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <PhoneInput
                        country={"ae"}
                        enableSearch
                        value={formData.phone}
                        onChange={(phone) =>
                          setFormData({ ...formData, phone })
                        }
                        inputStyle={{
                          width: "100%",
                          height: "50px",
                          paddingLeft: "60px",
                          borderRadius: "0.375rem",
                          border: "1px solid #c69933",
                        }}
                        containerStyle={{ width: "100%" }}
                        buttonStyle={{ border: "none" }}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label">Profession</label>
                      <input
                        type="text"
                        className="form-control custom-input"
                        placeholder="Enter profession"
                        value={formData.profession}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            profession: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={prevStep}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={nextStep}
                        style={{
                          backgroundColor: "#bdaa7d",
                          border: "2px solid #c69933",
                        }}
                      >
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </>
                )}

                {/* Step 3 */}
                {step === 3 && (
                  <>
                    <div style={{ position: "relative", zIndex: 1000 }}>
                      <div className="mb-4 mt-4">
                        <label className="form-label mb-2">
                          Interested Services
                        </label>
                        <Select
                          isMulti
                          options={options}
                          value={selectedServices}
                          onChange={handleServiceChange}
                          placeholder="Search and select services..."
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: "1px solid #c69933",
                              boxShadow: "none",
                              "&:hover": {
                                border: "1px solid #c69933",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#f0e6d2",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "#5a4a2a",
                            }),
                          }}
                        />
                      </div>
                    </div>

                    <div className="mb-3 position-relative">
                      <label htmlFor="" className="form-label mb-2">
                        {" "}
                        Prefer Appointment Date and Time
                      </label>
                      <BsCalendar2
                        className="position-absolute"
                        style={{
                          top: "70%",
                          left: "15px",
                          transform: "translateY(-50%)",
                          color: "#c69933",
                          zIndex: 10,
                        }}
                      />
                      <DatePicker
                        selected={formData.appointmentDate}
                        onChange={(date) =>
                          setFormData({ ...formData, appointmentDate: date })
                        }
                        minDate={new Date()}
                        placeholderText="Preferred Appointment Date & Time"
                        className="form-control w-100 ps-5"
                        wrapperClassName="w-100"
                        showTimeSelect
                        dateFormat="Pp"
                      />
                    </div>

                    <div className="text-center ">
                      <img
                        src={tabbyImages}
                        alt="tabbyimage"
                        style={{ maxWidth: "200px", height: "auto" }}
                        className="img-fluid"
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={prevStep}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <button
                        type="submit"
                        className="px-3 py-1 rounded text-white"
                        style={{
                          backgroundColor: "#bdaa7d",
                          border: "2px solid #c69933",
                        }}
                      >
                        {isSubmitting ? "Submitting..." : " Book Now "}
                      </button>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>

          <div className="accordion">
            {faqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <button
                  className={`accordion-header ${
                    activeAccordion === index ? "active" : ""
                  }`}
                  onClick={() => toggleAccordion(index)}
                >
                  {faq.question}
                  <span className="accordion-icon">
                    {activeAccordion === index ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`accordion-content ${
                    activeAccordion === index ? "open" : ""
                  }`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CSS Styles */}
      <style jsx>{`
        .contact-page {
          font-family: "Arial", sans-serif;
          // color: #333;
        }

        /* Hero Section */
        .contact-hero {
          background-size: cover;
          background-position: center;
          padding: 100px 0;
          text-align: center;
          color: white;
          position: relative;
        }

        .contact-hero::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
        }

        .contact-hero .container {
          position: relative;
          z-index: 1;
        }

        .contact-hero h1 {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .breadcrumb {
          font-size: 16px;
        }

        .breadcrumb a {
          color: white;
          text-decoration: none;
        }

        .breadcrumb span {
          color: #f0f0f0;
        }

        /* Contact Info Section */
        .contact-info-section {
          padding: 80px 0;
          // background-color: #c69933;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        @media (max-width: 992px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }

        .contact-details,
        .contact-form-container {
          border-radius: 8px;
        }

        .contact-details h2,
        .contact-form-container h2 {
          font-size: 28px;
          margin-bottom: 20px;
          color: #222;
        }

        .contact-method {
          margin-bottom: 25px;
        }

        .contact-method h3 {
          font-size: 18px;
          color: #555;
          margin-bottom: 10px;
        }

        .contact-method p {
          line-height: 1.6;
        }

        .contact-map {
          height: 100%;
          min-height: 400px;
          border-radius: 8px;
          overflow: hidden;
        }

        .contact-map iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        /* Contact Form */
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group label {
          margin-bottom: 8px;
          font-weight: 500;
        }

        .form-group input {
          padding: 12px 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 16px;
        }

        .submit-btn {
          background-color: #c69933;
          color: white;
          border: none;
          padding: 14px 20px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        .submit-btn:hover {
          background-color: #c69933;
        }

        /* FAQ Section */
        .faq-section {
          padding: 80px 0;
          background: white;
        }

        .faq-section h2 {
          text-align: center;
          font-size: 32px;
          margin-bottom: 40px;
        }

        .accordion {
          max-width: 800px;
          margin: 0 auto;
        }

        .accordion-item {
          margin-bottom: 15px;
          border: 1px solid #eee;
          border-radius: 8px;
          overflow: hidden;
        }

        .accordion-header {
          width: 100%;
          padding: 18px 20px;
          background: #f0f0f0;
          border: none;
          text-align: left;
          font-size: 18px;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: background 0.3s;
        }

        .accordion-header:hover {
          background: #c69933;
        }

        .accordion-header.active {
          background: #c69933;
          color: white;
        }

        .accordion-icon {
          font-size: 20px;
          font-weight: bold;
        }

        .accordion-content {
          padding: 0 20px;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out, padding 0.3s ease;
        }

        .accordion-content.open {
          padding: 20px;
          max-height: 300px;
        }

        .accordion-content p {
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
};

export default ContactUsPage;
